var _circle, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLoss = function SvgLoss(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E02020"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.948 16.624c-.034.082-.084.156-.146.218l-.011.008c-.06.057-.13.105-.208.137-.064.027-.13.035-.198.04-.02.002-.037.012-.057.012H13.95c-.372 0-.673-.3-.673-.673 0-.371.3-.672.673-.672h3.762l-5.322-5.352-2.025 2.592c-.117.15-.29.243-.48.257-.195.014-.375-.052-.512-.182L4.21 8.121c-.27-.255-.281-.681-.026-.95.133-.14.31-.21.489-.21.166 0 .332.062.461.184l4.626 4.38 2.04-2.61c.118-.153.296-.247.49-.258.192-.01.38.06.516.197l5.85 5.883v-3.749c0-.371.3-.672.672-.672.372 0 .672.3.672.672V16.367c0 .088-.018.175-.052.257z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z",
    transform: "matrix(1 0 0 -1 4 20)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loss.c27af075.svg";
export { ForwardRef as ReactComponent };